import { config } from '../../config';

export async function checkIfHasHybridFlowRefreshToken() {
  return Boolean(localStorage.getItem(config.hybridFlowRefreshTokenStorageKey));
}
